import React from "react";

export const ContentWrapper = ({
  children,
  isAuthorized,
  isSaving,
  onSave,
}) => {
  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="setting-setion">
          <div className="membershipSectionTitle">Sync Settings</div>
          <div className="wallet-edit-block">
            <div className="membershipSectionContent row">{children}</div>
            {isAuthorized && (
              <div className="footer-static">
                <button
                  className="new-blue-btn pull-right"
                  disabled={isSaving}
                  onClick={() => {
                    if (!isSaving) {
                      onSave();
                    }
                  }}
                >
                  {isSaving ? "Saving..." : "Save"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
